import { getThumbnailUrlWithToken } from "connection/mux";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

// Mux streams with jwt privacy enabled still require jwt signatures for their thumbnails
// this will check if the image requires a jwt token and async update the background image url 
// when the token is available and the image is in view
export default function VideoBackgroundImage(props: React.HTMLAttributes<HTMLDivElement> & { preload?: boolean, eventUuid?: string }) {
	const [bgImage, setBgImage] = useState<string | undefined>(props.style?.backgroundImage);
	const { ref, inView } = useInView({ threshold: 0.1, rootMargin: "-100px", initialInView: props.preload });
	const { eventUuid, ...rest } = props;

	useEffect(() => {
		if (props.style?.backgroundImage && inView) {
			const url = props.style.backgroundImage.replace(/url\(["']?/, "").replace(/["']?\)$/, "");
			getThumbnailUrlWithToken(url, eventUuid).then(res => {
				if (res instanceof Error) {
					console.error("Error fetching background image URL:", res);
					setBgImage(undefined);
					return;
				}
				setBgImage(res);
			});
		}
	}, [props.style?.backgroundImage, inView, eventUuid]);

	return (
		<div
			ref={ref}
			{...rest}
			data-testid="video-background-image"
			style={{
				...props.style,
				backgroundImage: `url(${bgImage})`,
			} as React.CSSProperties}
		>
			{props.children}
		</div>
	);
}